import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { rateApp } from 'queries';

export default new AsyncActionHandler({
  name: 'rate_app',
  handler: (id, stars) => async () => {
    const { data } = await apollo.mutate({
      mutation: rateApp,
      variables: {
        id,
        stars
      }
    });

    return {
      app: data.rateApp
    };
  },
  reduce(state, { app }) {
    if (!app) {
      return state;
    }

    return {
      apps: {
        ...state.apps,
        [app.id]: app
      }
    };
  }
});
